import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { appConfig } from '../config/appConfig';

const LoginPage = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto h-16 w-16 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl flex items-center justify-center mb-8">
            <span className="material-icons text-white text-3xl">chat</span>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            {appConfig.name}에 오신 것을 환영합니다
          </h2>
          <p className="text-gray-600 mb-8">
            {appConfig.description}
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
          <button
            onClick={() => loginWithRedirect()}
            className="w-full flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-xl text-white bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 transform hover:scale-105"
          >
            <span className="material-icons mr-2">login</span>
            로그인하고 시작하기
          </button>

          <div className="text-center">
            <p className="text-sm text-gray-500">
              안전하고 보안이 검증된 Auth0를 통해 로그인합니다
            </p>
          </div>
        </div>

        <div className="text-center">
          <div className="flex items-center justify-center space-x-6 text-sm text-gray-500">
            <div className="flex items-center">
              <span className="material-icons text-green-500 mr-1 text-sm">verified</span>
              보안 인증
            </div>
            <div className="flex items-center">
              <span className="material-icons text-blue-500 mr-1 text-sm">speed</span>
              빠른 응답
            </div>
            <div className="flex items-center">
              <span className="material-icons text-purple-500 mr-1 text-sm">smart_toy</span>
              고급 AI
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 